export default __webpack_public_path__ + "static/media/war4.7f53ac00.png";